var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"login-button",attrs:{"variant":"primary","href":_vm.loginAddress}},[_c('translate',[_vm._v(" Login ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }